const Markets = {
  xcp: 'xcp',
  dispenser: 'dispenser',
  openSea: 'openSea'
}

export default Markets
